<template>
  <div class="mt-5" v-if="selectedThread">
    <h2>{{ selectedThread.subject }}</h2>
    <b-button :to="{ name: 'messages' }" variant="secondary" size="sm" class="mb-2">
      Tilbake
    </b-button>
    <hr />
    <h5>Meldinger</h5>
    <div class="mb-4">
      <div
        v-for="message in selectedThread.messages"
        :key="message.id"
        class="d-flex flex-column w-100 mb-3"
      >
        <div class="w-50" :class="{ 'align-self-end': user.id !== message.user_id }">
          <div
            class="rounded px-3 py-2"
            :class="{
              'bg-light': user.id === message.user_id,
              'bg-primary text-white align-self-end': user.id !== message.user_id,
            }"
          >
            {{ message.body }}
          </div>
          <small>{{ message.created_at }}</small>
        </div>
      </div>
    </div>
    <hr />
    <b-form @submit.prevent="onSubmit">
      <b-form-group id="content" label="Svar" label-for="message">
        <b-form-textarea
          id="message"
          v-model="form.message"
          type="text"
          required
          placeholder="Hei, jeg lurer på..."
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="primary">Send</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  mounted() {
    this.getThreads();
  },
  data() {
    return {
      form: {
        message: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      thread: 'messages/getThreadById',
      user: 'auth/getUser',
    }),
    selectedThread() {
      return this.thread(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions({
      getThreads: 'messages/getThreads',
      postAnswer: 'messages/postAnswer',
    }),
    onSubmit() {
      this.postAnswer({ form: this.form, id: this.$route.params.id }).then(_ => {
        this.form.message = '';
      });
    },
  },
};
</script>

<style>
</style>
